import { ReactNode } from 'react';

export interface SortKey {
  key: string;
  desc?: boolean;
}
export interface TableColumnProps {
  Header: string | ReactNode;
  accessor: string;
  Cell?: (row: any) => ReactNode;
  sortable?: boolean;
}
export interface TableProps {
  data: any[];
  columns: TableColumnProps[];
  noDataText: ReactNode | string;
  sortedBy?: SortKey;
  onSortingRequested?: (sortBy: SortKey) => void;
  pageSize?: number;
  paginationPosition?: 'topRight' | 'bottomRight';
  filterable?: boolean;
}
